import { useEffect, RefObject } from 'react';

type EventType = MouseEvent | TouchEvent;

export const useOutsideClick = (ref: RefObject<any>, callback: () => void) => {
  useEffect(() => {
    const handleClickOutside = (event: EventType) => {
      if (ref.current
        && !ref.current.contains(event.target as Node)
        && !ref.current.isEqualNode(event.target as Node)
      ) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [ref, callback]);
};
